import React, { useState, useEffect } from "react";
import axios from "axios";
import { LinkContainer } from "react-router-bootstrap";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { AiFillEdit, AiOutlineRollback } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
  updateOffice,
  getOfficeById,
  resetOfficeUpdate,
  resetOfficeDetails,
} from "../features/deliveryoffice/officeSlice";
import { toast } from "react-toastify";
import Loader from "../components/Loader";

const UpdateDeliveryOffice = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  //user Selector
  const { userInfo } = useSelector((state) => state.user);

  const {
    office,

    isDetailsLoading,
    isDetailsError,
    isDetailsSuccess,
    detailsErrorMessage,

    isUpdateLoading,
    isUpdateError,
    isUpdateSuccess,
    updateErrorMessage,
  } = useSelector((state) => state.office);

  //Office States
  const [name, setName] = useState("");
  const [rlNumber, setRlNumber] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");

  useEffect(() => {
    if (!userInfo) {
      toast.error("Please Login to Get Access", { position: "top-center" });
      navigate("/login");
    }
  }, [userInfo, navigate]);

  useEffect(() => {
    if (isDetailsError) {
      toast.error(detailsErrorMessage, { position: "top-center" });
    } else if (isDetailsSuccess) {
      setName(office.officeName);
      setRlNumber(office.rlNumber);
      setPhone(office.officePhone);
      setAddress(office.officeAddress);
    } else {
      dispatch(getOfficeById(params.id));
    }
  }, [isDetailsError, isDetailsSuccess, isDetailsError]);

  useEffect(() => {
    if (isUpdateError) {
      toast.error(updateErrorMessage, { position: "top-center" });
    } else if (isUpdateSuccess) {
      toast.success("Office Updated Successfully", { position: "top-center" });
      navigate("/deliveryOfficeList");
    }
  }, [isUpdateError, updateErrorMessage, isUpdateSuccess]);

  useEffect(() => {
    return () => {
      dispatch(resetOfficeDetails());
      dispatch(resetOfficeUpdate());
    };
  }, [dispatch]);

  const updateHandler = () => {
    const office = {
      officeName: name,
      rlNumber: rlNumber,
      officePhone: phone,
      officeAddress: address,
    };
    dispatch(updateOffice({ id: params.id, office }));
  };

  return (
    <>
      {isDetailsLoading || isUpdateLoading ? (
        <Loader />
      ) : isDetailsError ? (
        <h4 variant="danger">{detailsErrorMessage}</h4>
      ) : (
        <Container fluid className="my-4">
          <h2 style={{ fontWeight: "bold " }} className="mb-4 text-center">
            Update Delivery Office
          </h2>

          <Form>
            <Row>
              {/* Column For Form */}
              <Col sm={12} md={12} lg={12}>
                <Card className="mb-4 shadow rounded">
                  <Card.Header
                    as="h5"
                    className="text-black p-3 fw-bold text-center"
                    style={{ backgroundColor: "#74a2e3" }}
                  >
                    Delivery Office Information
                  </Card.Header>
                  <Card.Body className="fw-bold">
                    <Row>
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="OfficeName">
                          <Form.Label>Office Name</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder={
                              name === ""
                                ? "Name is Required"
                                : "Enter Office Name"
                            }
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="rlNumber">
                          <Form.Label>RL Number</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder={
                              rlNumber === ""
                                ? "RL Number is Required"
                                : "Enter RL Number"
                            }
                            value={rlNumber}
                            onChange={(e) => setRlNumber(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="OfficePhone">
                          <Form.Label>Office Phone</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder={
                              phone === ""
                                ? "Phone is Required"
                                : "Enter Phone Number"
                            }
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="OfficeAddress">
                          <Form.Label>Office Address</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            type="textarea"
                            placeholder={
                              address === ""
                                ? "Address is Required"
                                : "Enter Office Address"
                            }
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mt-4">
                      <Col sm={12} md={6} lg={6} className="px-4">
                        <Row>
                          <Button
                            variant="outline-primary"
                            type="submit"
                            className="rounded"
                            onClick={updateHandler}
                          >
                            <AiFillEdit className="mb-1" size={18} />
                            Update Office
                          </Button>
                        </Row>
                      </Col>

                      <Col sm={12} md={6} lg={6} className="px-4">
                        <Row>
                          <LinkContainer to={`/deliveryOfficeList`}>
                            <Button
                              variant="outline-secondary"
                              className="rounded"
                            >
                              <AiOutlineRollback className="mb-1" size={18} />
                              Back To List
                            </Button>
                          </LinkContainer>
                        </Row>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Form>
        </Container>
      )}
      ;
    </>
  );
};

export default UpdateDeliveryOffice;
